gsap.registerPlugin(ScrollTrigger);
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollToPlugin);
import { ScrollToPlugin } from "gsap/all";
const scrollTop = {
  init() {
    let totop = document.querySelector(".totop");

    gsap.to('.totop', {
      scrollTrigger: {
        
        trigger:'main',
        //markers: true,
        start: 'center center',
        //scrub: true,
        toggleActions: "play none none reverse",
      },
      opacity: 1,
      
    });



    totop.addEventListener("click", () =>
      scrollTo("#header", true, "top 100px")
    );
  },
};

export default scrollTop;
